/* eslint-disable class-methods-use-this */
/* eslint-disable max-classes-per-file */

import { RequestBase } from '../requestBase';
import { APIRoutes } from '../apiRoutes';

export class RequestChannelPasswordChange extends RequestBase {

  public override getAPIEndPoint(): string {
    return APIRoutes.Users_Channel_Password_Change;
  }

  public channelName = '';
  public userName = '';
  public oldPassword = '';
  public newPassword = '';
}

export class ResponseChannelPasswordChange {
  public result = false;
}
